
export const Theme = {
  media: [
    'flex flex-row items-center rounded-lg border border-2 border-dashed border-gray-200 bg-gray-25 gap-4 p-5',
    'dark:bg-gray-700 dark:border-gray-600',
  ],
  mediaError: 'border-danger'
}
